// extracted by mini-css-extract-plugin
export default {"customReportTextContainer":"CustomReportText_customReportTextContainer__4PBa7","viewMode":"CustomReportText_viewMode__fGS8I"};